
// Product Schema
export function findInArrayByKey(array, key, value) {

    if (!Array.isArray(array)) {
        return false;
    }

    let element = null;

    array.map(function (item, index) {

        if (item[key] == value) {
            element = item;
        }

    });

    return element;
}